module.exports = __webpack_public_path__ + "img/coin-transfer-out.3f78aa75.png";